module.exports = __webpack_public_path__ + "img/title3.89128802.png";